// extracted by mini-css-extract-plugin
export default {"wrapper":"curd_wrapper__o1rqr","attachments":"curd_attachments__6Wpgz"};